// Centralised site config + service data
export const SITE = {
  name: "Mulberry Land Services",
  shortName: "Mulberry",
  tagline: "Reclaim your land. Build on solid ground.",
  phone: "(678) 693-3855",
  phoneHref: "tel:+16786933855",
  email: "MulberryLandServices@gmail.com",
  address: "4295 Platinum Ct, Hoschton, GA 30548",
  serviceArea: "Proudly serving North Georgia",
  hours: "Mon – Sat · 7:00 AM – 6:00 PM",
  founded: 2009,
  jobsCompleted: "1,200+",
  acresCleared: "4,800+",
};

export const SERVICES = [
  {
    slug: "forestry-mulching",
    title: "Forestry Mulching",
    short: "One-pass clearing of brush, saplings, and overgrowth.",
    description:
      "Our high-flow mulchers grind underbrush, invasive species, and trees up to 10\" in a single pass — leaving behind a nutrient-rich mulch layer that protects soil from erosion. No burning, no hauling, no disturbed root systems.",
    bullets: [
      "Selective tree retention",
      "Erosion control & soil enrichment",
      "No burning required",
      "Access for tight or steep terrain",
    ],
    image: "https://customer-assets.emergentagent.com/job_forestry-mulch-pro/artifacts/7s7rivse_images.jfif",
    icon: "Trees",
  },
  {
    slug: "land-clearing",
    title: "Land Clearing",
    short: "Full-scale clearing for development, agriculture, or pasture.",
    description:
      "From overgrown lots to multi-acre tracts, we remove trees, stumps, and debris. We pair the right machine to the job — dozers, skid steers, excavators — so the land is ready for whatever comes next.",
    bullets: [
      "Tree & stump removal",
      "Brush hauling and debris management",
      "Right-of-way & fence-line clearing",
      "Pad-ready sites",
    ],
    image: "https://images.pexels.com/photos/11118633/pexels-photo-11118633.jpeg",
    icon: "Axe",
  },
  {
    slug: "grading-excavation",
    title: "Grading & Excavation",
    short: "Precision earthwork for foundations, pads, and landscapes.",
    description:
      "Whether you need a level building pad, a graded yard, or trenches for utilities, our excavator operators bring the precision and the heavy equipment to make it happen — on schedule, to spec.",
    bullets: [
      "Building pads & footings",
      "Yard re-grading & sloping",
      "Utility trenching",
      "Pond & pool excavation",
    ],
    image: "https://images.pexels.com/photos/6245621/pexels-photo-6245621.jpeg",
    icon: "Mountain",
  },
  {
    slug: "drainage",
    title: "Drainage Solutions",
    short: "Stop standing water and protect your foundation.",
    description:
      "We design and install drainage systems that move water away from where it shouldn't be: french drains, surface drains, swales, culverts, and downspout tie-ins. Every site assessed individually.",
    bullets: [
      "French drains & catch basins",
      "Swales & surface re-grading",
      "Culvert installs & replacements",
      "Foundation perimeter drains",
    ],
    image: "https://images.pexels.com/photos/37627673/pexels-photo-37627673.jpeg",
    icon: "Waves",
  },
  {
    slug: "driveway-site-prep",
    title: "Driveway & Site Prep",
    short: "Gravel driveways and build-ready sites you can count on.",
    description:
      "Properly built driveways last decades. We strip topsoil, compact a base, lay geotextile fabric where required, and finish with the right aggregate — from rural drives to commercial entrances.",
    bullets: [
      "Gravel driveway construction",
      "Site stripping & compaction",
      "Culvert & apron installation",
      "Sub-base & finish grading",
    ],
    image: "https://images.unsplash.com/photo-1763515187478-9934edce7158",
    icon: "Route",
  },
  {
    slug: "demolition",
    title: "Demolition",
    short: "Tear-downs of barns, sheds, and small structures.",
    description:
      "We safely demolish outbuildings, barns, garages, and other small structures — including hauling debris off-site and leaving the area graded and ready for its next chapter.",
    bullets: [
      "Outbuilding & barn tear-down",
      "Concrete pad removal",
      "Debris hauling & disposal",
      "Site clean-up & re-grading",
    ],
    image: "https://images.pexels.com/photos/10451774/pexels-photo-10451774.jpeg",
    icon: "Hammer",
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => ({ value: s.slug, label: s.title }));

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Request Quote" },
];
